<template lang="pug">
    DropdownShifter.b-dropdown(:class="{ opened: isOpened, dark, noTriangle }" :opened="isOpened" center)
      ul._container.list-reset
        li._item(v-for="item in items" :key="item.text")
          router-link._link(v-if="item.route" :to="item.route" @click="onItemClick(item)")
            Icon(:name="item.icon")
            | {{ item.text }}
          ._link(v-else @click="onItemClick(item)")
            Icon(:name="item.icon")
            | {{ item.text }}
</template>

<script>
import DropdownShifter from '@/components/base/DropdownShifter.vue';

export default {
  name: 'CommonDropdown',
  components: { DropdownShifter },
  props: {
    items: {
      type: Array,
      required: true,
    },
    isOpened: {
      type: Boolean,
      required: true,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    noTriangle: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onItemClick(item) {
      if (item.handler) {
        item.handler();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.dropdown {
  position: absolute;

  opacity: 0;
  z-index: 200;

  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

  &.noTriangle {
    &:before {
      display: none;
    }
  }

  &.dark {
    .dropdown {
      &__container {
        background-color: #3D536B;
        color: var(--color-white);
      }

      &__link {
        stroke: var(--color-white);
        fill: var(--color-white);
        &:hover {
          background-color: #587695;
        }
      }
    }
  }

  &__container {
    position: relative;

    background-color: var(--color-white);
    color: var(--color-middle-gray);
    border-radius: 6px;
    box-shadow: 0 2px 30px rgba(0, 0, 0, 0.12);
    padding: 8px 0;
  }

  &.opened {
    opacity: 1 !important;
    visibility: visible !important;
  }

  &:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: -16px;
    right: 28px;
    width: 32px;
    height: 16px;
    background-image: url(../assets/img/svg/triangle.svg);
    background-size: cover;
    background-repeat: no-repeat;
  }
  &__item {
    margin-bottom: -1px;
    &:last-child {
      .dropdown__link {
        &:after {
          display: none;
        }
      }
    }
  }
  &__link {
    position: relative;
    padding: 12px 20px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    font-size: 14px;
    transition: color 0.1s;
    cursor: pointer;
    &:after {
      content: "";
      display: inline-block;
      position: absolute;
      bottom: 0;
      left: 20px;
      right: 20px;
      height: 1px;
      background-color: var(--color-purple);
    }
    &:hover {
      background-color: var(--color-purple);
      &:after {
        display: none;
      }
    }
    svg {
      display: block;
      width: 16px;
      height: 16px;
      fill: #788CA1;
      margin-right: 10px;
      transition: fill 0.1s;
    }
  }
}
</style>
